<template>
  <div class="relative w-full h-96">
    <div id="map" class="w-full h-full"></div>
    <div 
      v-if="!isMapActive"
      class="absolute inset-0 flex items-center justify-center pointer-events-none"
    >
      <div class="bg-white/90 px-4 py-2 rounded-lg shadow-lg text-sm text-gray-700">
        Click to interact with map
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
const isMapActive = ref(false)

onMounted(async () => {
  // Dynamically import Leaflet only on client
  const L = await import('leaflet')

  // Initialize the map with scroll wheel zoom disabled
  const map = L.map('map', {
    scrollWheelZoom: false
  }).setView([40.7128, -74.0060], 13)

  // Add a tile layer
  L.tileLayer('https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png', {
    attribution: '&copy; OpenStreetMap contributors'
  }).addTo(map)

  // Add a marker
  L.marker([40.7128, -74.0060])
    .addTo(map)
    .bindPopup('Our Store Location')
    .openPopup()

  // Enable scroll wheel zoom when user clicks on the map
  map.on('click', () => {
    map.scrollWheelZoom.enable()
    isMapActive.value = true
  })

  // Disable scroll wheel zoom when mouse leaves the map
  map.on('mouseout', () => {
    map.scrollWheelZoom.disable()
    isMapActive.value = false
  })
})
</script>
